import React, { useState } from 'react';
import Select from 'react-select';

type OptionType = { value: string; label: string };

interface CustomSelectProps {
  options: OptionType[];
  value: string;
  name: string;
  onChange: (e: { target: { name: string; value: string } }) => void;
  placeholder?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  name,
  onChange,
  placeholder,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Select
      inputId={name}
      classNamePrefix="custom-select-field"
      className="custom-select"
      options={options}
      value={selectedOption}
      onChange={(selectedOption) => {
        onChange({
          target: { name, value: selectedOption ? selectedOption.value : '' },
        });

        // Close menu when cleared
        if (!selectedOption) {
          setMenuIsOpen(false);
        }
      }}
      placeholder={placeholder}
      isClearable
      menuIsOpen={menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      styles={{
        control: (provided) => ({
          ...provided,
          border: 'none',
          borderBottom: '1px solid #B6C38066',
          backgroundColor: 'transparent',
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 300,
          paddingTop: 6,
          paddingBottom: 6,
          boxShadow: 'none',
          borderRadius: 0,
          outline: 'none',
          '&:hover': {
            borderBottom: '1px solid #B6C38066',
          },
        }),
        singleValue: (provided) => ({
          ...provided,
          color: value ? '#B6C380' : '#B6C38066',
          fontSize: '14px',
          fontWeight: 300,
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: '#B6C38066',
          padding:0
        }),
        clearIndicator: (provided, state) => ({
          ...provided,
          color: '#B6C38066',
          display: state.hasValue ? 'none' : 'none',
          '&:hover': {
            color: '#B6C38066',
          },
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: '#2b332a', // Dropdown background
          zIndex: 20,
          margin:'0',
  
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused
            ? '#3b4a35' // <-- New hover background color
            : '#1c1c1c', // Default background
          color: state.isFocused
            ? '#B6C380' // <-- New hover text color
            : state.isSelected
              ? '#B6C380'
              : '#B6C38066',
          fontSize: '14px',
          fontWeight: 300,
          paddingTop: 6,
          paddingBottom: 6,
          paddingLeft: 8,
          paddingRight: 8,
          borderBottom: '1px solid #B6C38066',
          cursor: 'pointer',
          '&:active': {
            backgroundColor: '#2b332a',
          },
        }),
        menuList: (provided) => ({
          ...provided,
          paddingTop: 0,
          paddingBottom: 0,
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: '14px',
          color: '#B6C38066',
          fontWeight: 300,
        }),
      }}
    />
  );
};

export default CustomSelect;
